import React, { useState } from "react";
import CreatableSelect from "react-select/creatable";

const EventTagsSelector = ({ selectedTags, onChange }) => {
  const [showHelp, setShowHelp] = useState(false);

  return (
    <div
      className="space-y-1 relative"
      onMouseEnter={() => setShowHelp(true)}
      onMouseLeave={() => setShowHelp(false)}
    >
      <div className="flex items-center justify-between">
        <label className="block text-sm font-medium text-gray-700">
          Tags (optional)
        </label>
        <span className="text-xs text-blue-500 italic cursor-help">
          {showHelp && (
            <span className="absolute top-full mt-1 right-0 bg-white border border-gray-200 shadow-md p-2 text-xs text-gray-600 rounded w-64 z-10">
              Tags help with searching and filtering events later, e.g. “music”, “exam”, “sports”.
            </span>
          )}
          What are these?
        </span>
      </div>

      <CreatableSelect
        isMulti
        value={selectedTags}
        onChange={(val) => onChange("tags", val)}
        placeholder="Add tags like music, exam, futsal..."
        className="text-sm"
        classNamePrefix="react-select"
      />
    </div>
  );
};

export default EventTagsSelector;
